import "./App.css";
import { Button } from "@chakra-ui/react";
import { useEffect, useLayoutEffect, useState } from "react";
import hotToast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router";
import TokenManager from "./providers/auth/token-manager";
import { selectCells, setCells, setFlows } from "./store/slices/node.slice";
import { GetUpdatedFlows } from "./utils/flow-utils";
import useGlobalVariables from "./utils/global-variables";
import { useHttpClient } from "./utils/http.utils";

function setVendor() {
    // eslint-disable-next-line no-undef
    const urlParams = new URLSearchParams(window.location.search);
    let vendorCode = urlParams.get("vendor");

    if (vendorCode) {
        vendorCode = vendorCode.replace("/", "");
    }

    /**
     * Set application code in session storage
     */
    if (vendorCode) {
        // eslint-disable-next-line no-undef
        sessionStorage.setItem("vendorId", vendorCode);
    }
}

function App() {
    const { editor } = useGlobalVariables();
    const [isLoading, setIsLoading] = useState(false);
    const [initialFlows, setInitialFlows] = useState({});
    const [authToken, setAuthToken] = useState<string>("");

    const {
        listMemoryApi,
        listToolApi,
        updateCollaborationAppApi,
        loadCollaborationAppDetailsApi,
        listPersonaApi,
        listPrivateStructuredDbsApi,
        listTransactionCoordinatorCataloguesApi,
        listTransactionCoordinatorEventsApi,
        listPrivateCampaignTemplatesApi,
        getClientApi
    } = useHttpClient();
    const dispatch = useDispatch();

    const cells = useSelector(selectCells);

    useLayoutEffect(() => {
        // Set vendor Id before functions
        setVendor();
    }, []);

    useEffect(() => {
        const getToken = async () => {
            const tokenManager = TokenManager.getInstance();
            const token = await tokenManager.getToken();

            setAuthToken(token);
        };
        getToken();
    }, []);

    useEffect(() => {
        if (authToken) {
            (async () => {
                await listMemoryApi();
                await listToolApi();
                // List persona
                await listPersonaApi();

                await listPrivateStructuredDbsApi();

                await listPrivateCampaignTemplatesApi();

                await getClientApi();

                await listTransactionCoordinatorCataloguesApi();

                await listTransactionCoordinatorEventsApi();
            })();
        }
    }, [authToken]);

    useEffect(() => {
        if (authToken) {
            const loadAppDetails = async () => {
                const data = await loadCollaborationAppDetailsApi();

                dispatch(setCells(data?.json_structure?.cells));
                dispatch(setFlows(data?.json_structure?.flows));
                setInitialFlows(data?.json_structure?.flows);
            };

            if (cells.length <= 0) {
                loadAppDetails();
            }
        }
    }, [authToken]);

    const saveData = async () => {
        const { updatedFlows } = GetUpdatedFlows(editor);
        const _updatedFlows: any = structuredClone(initialFlows);
        _updatedFlows[0].cell_list = updatedFlows;
        dispatch(setFlows(_updatedFlows));
        // console.log(_updatedFlows);
        const toastId = hotToast.loading("Saving..");
        try {
            // Implementation to save data
            setIsLoading(true);
            await updateCollaborationAppApi();
            hotToast.success("Saved!");
        } catch (error) {
            console.log(error);
            hotToast.error("Cannot save your application at this time. Please try again later.");
        } finally {
            setIsLoading(false);
            hotToast.dismiss(toastId);
        }
    };

    if (!authToken) {
        return <div></div>;
    }

    return (
        <>
            <Outlet />
            <div id="global-save-btn" className="panel-contents-footer">
                {/* <button id="save-btn"  className="save-btn">
                    SAVE
                </button> */}
                <Button
                    className="save-btn"
                    onClick={saveData}
                    isLoading={isLoading}
                    colorScheme="red"
                >
                    Save
                </Button>
            </div>
        </>
    );
}

export default App;
